import { render } from "./EditPostModal.vue?vue&type=template&id=34a70996&scoped=true&ts=true"
import script from "./EditPostModal.vue?vue&type=script&lang=ts"
export * from "./EditPostModal.vue?vue&type=script&lang=ts"

import "./EditPostModal.vue?vue&type=style&index=0&id=34a70996&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a70996"]])

export default __exports__